// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"60becb77","239":"d3276912","453":"9321e060","732":"40e520f1"}[chunkId] + ".chunk.js";
};